import styled from '@emotion/styled'
import Triangle from './ExclamationTriangle'
import { fontWeightRegular, fontSize3XSmall, black, goldLight10, fontWeightSemibold, fontFamilyOpenSans } from '../../constants/principles'

export default ({ text, testId }) => (
  <Warning indent={0} data-testid={`${testId}-title`} fontWeight={fontWeightRegular}>
    <SpacedSpan>
      <Triangle colorFill={goldLight10} width={20} height={20} />
    </SpacedSpan>
    {text}
  </Warning>
)

const SpacedSpan = styled.span`
  padding-right: 8px;
  display: flex;
`
const Warning = styled.p`
  font-size: ${fontSize3XSmall};
  font-weight: ${p => (p.fontWeight ? p.fontWeight : fontWeightSemibold)};
  font-family: ${fontFamilyOpenSans};
  color: ${black};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  margin: 8px 0;
  padding-left: ${p => p.indent}px;
`
